import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticlePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>

            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              Руководство
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              YOYBUY Spreadsheet: Полное руководство по покупкам из Китая через систему таблиц
            </h1>

            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Узнайте, как использовать <strong>YOYBUY Spreadsheet</strong> для выгодных покупок из Китая.
              Пошаговое руководство по системе таблиц, сравнению цен и оптимизации заказов.
            </p>

            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 8 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Что такое YOYBUY Spreadsheet?
              </h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                <strong>YOYBUY Spreadsheet</strong> — это инновационная система таблиц, созданная специально для
                удобного заказа товаров из Китая. В отличие от традиционных агентов и посредников, YOYBUY Spreadsheet
                предоставляет прямой доступ к актуальным ценам, наличию и характеристикам тысяч товаров в одном
                структурированном формате.
              </p>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Система работает на базе платформы <strong>Kaspreadsheet</strong> и охватывает 14 категорий товаров:
                от обуви и одежды до аксессуаров и парфюмерии. Каждая категория представлена в виде отдельной таблицы,
                где вы можете фильтровать, сортировать и сравнивать товары по цене, размеру, цвету и другим параметрам.
              </p>
              <div className="mt-6 p-5 bg-accent-50 rounded-2xl">
                <p className="text-sm text-accent-800 leading-relaxed">
                  <strong>Ключевое преимущество:</strong> YOYBUY Spreadsheet экономит до 40% времени и средств по
                  сравнению с традиционными методами заказа из Китая. Все данные обновляются ежедневно, а цены всегда
                  актуальны.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Как работает система таблиц YOYBUY?
              </h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Принцип работы <strong>YOYBUY Spreadsheet</strong> предельно прост. Вы выбираете нужную категорию
                товаров — например, обувь или аксессуары — и попадаете в структурированную таблицу на платформе
                Kaspreadsheet. В таблице уже собраны все актуальные предложения из Китая с указанием цен, размеров,
                цветов и наличия на складе.
              </p>

              <h3 className="text-xl font-heading font-semibold text-foreground-800 mt-8 mb-3">
                Пошаговая инструкция:
              </h3>
              <ol className="space-y-4">
                <li className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">1</span>
                  <div>
                    <h4 className="text-base font-semibold text-foreground-800">Выберите категорию товаров</h4>
                    <p className="text-sm text-foreground-500 mt-1">
                      На сайте <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link> выберите
                      интересующую категорию из выпадающего меню или сетки категорий. Доступно 14 категорий: обувь,
                      толстовки, футболки, куртки, брюки, головные уборы, комплекты, нижнее бельё, джерси, аксессуары,
                      сумки, ремни, парфюмерия и другие товары.
                    </p>
                  </div>
                </li>
                <li className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">2</span>
                  <div>
                    <h4 className="text-base font-semibold text-foreground-800">Перейдите к таблице на Kaspreadsheet</h4>
                    <p className="text-sm text-foreground-500 mt-1">
                      После выбора категории вы будете перенаправлены на <strong>Kaspreadsheet</strong>, где откроется
                      готовая таблица с товарами выбранной категории. Все данные структурированы и готовы к работе.
                    </p>
                  </div>
                </li>
                <li className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">3</span>
                  <div>
                    <h4 className="text-base font-semibold text-foreground-800">Фильтруйте и сравнивайте товары</h4>
                    <p className="text-sm text-foreground-500 mt-1">
                      Используйте встроенные фильтры таблицы для сортировки по цене, размеру, цвету и другим параметрам.
                      YOYBUY Spreadsheet позволяет быстро находить лучшие предложения.
                    </p>
                  </div>
                </li>
                <li className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">4</span>
                  <div>
                    <h4 className="text-base font-semibold text-foreground-800">Оформите заказ</h4>
                    <p className="text-sm text-foreground-500 mt-1">
                      Выбрав подходящие товары, следуйте инструкциям на Kaspreadsheet для оформления заказа. Система
                      поддерживает различные способы доставки и оплаты.
                    </p>
                  </div>
                </li>
              </ol>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Почему выбирают YOYBUY Spreadsheet?
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="p-5 bg-background-100 rounded-2xl">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className="ri-time-line text-accent-600"></i>
                  </div>
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">Экономия времени</h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Все товары уже собраны в одной таблице. Вам не нужно тратить часы на поиск и сравнение —
                    YOYBUY Spreadsheet делает это за вас.
                  </p>
                </div>
                <div className="p-5 bg-background-100 rounded-2xl">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className="ri-money-dollar-circle-line text-accent-600"></i>
                  </div>
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">Выгодные цены</h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Прямой доступ к ценам от поставщиков без посредников. Экономия до 40% по сравнению с традиционными
                    методами заказа из Китая.
                  </p>
                </div>
                <div className="p-5 bg-background-100 rounded-2xl">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className="ri-refresh-line text-accent-600"></i>
                  </div>
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">Ежедневное обновление</h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Данные о ценах и наличии обновляются ежедневно. Вы всегда видите актуальную информацию
                    и не рискуете заказать товар по старой цене.
                  </p>
                </div>
                <div className="p-5 bg-background-100 rounded-2xl">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className="ri-shield-check-line text-accent-600"></i>
                  </div>
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">Проверенные товары</h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    В таблицах YOYBUY только проверенные позиции от надёжных поставщиков. Вы получаете качественные
                    товары без риска нарваться на подделку.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Категории товаров в YOYBUY Spreadsheet
              </h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                На данный момент система <strong>YOYBUY Spreadsheet</strong> охватывает 14 категорий товаров.
                Каждая категория имеет собственную таблицу с полным набором данных:
              </p>
              <ul className="space-y-2">
                {[
                  'Обувь (Shoes) — кроссовки, ботинки, туфли и другая обувь из Китая',
                  'Толстовки и свитера (Hoodies/Sweaters) — тёплая одежда на любой сезон',
                  'Футболки (T-Shirts) — базовые и дизайнерские модели',
                  'Куртки (Jackets) — верхняя одежда от классики до спорта',
                  'Брюки и шорты (Pants/Shorts) — джинсы, брюки, шорты',
                  'Головные уборы (Headwear) — кепки, шапки, панамы',
                  'Комплекты (Sets) — готовые наборы одежды',
                  'Нижнее бельё (Underwear) — базовые модели',
                  'Джерси (Jersey) — спортивная форма',
                  'Аксессуары (Accessories) — часы, очки, украшения',
                  'Сумки (Bags) — рюкзаки, сумки, клатчи',
                  'Ремни (Belts) — кожаные и текстильные ремни',
                  'Парфюмерия (Perfumes) — ароматы из Китая',
                  'Другие товары (Other Stuff) — всё остальное',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-accent-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Советы по эффективному использованию YOYBUY Spreadsheet
              </h2>
              <div className="p-5 bg-secondary-50 rounded-2xl mb-5">
                <h4 className="text-base font-semibold text-foreground-800 mb-2">
                  Совет №1: Сравнивайте перед покупкой
                </h4>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Всегда сравнивайте минимум 3-5 позиций в таблице перед тем, как сделать выбор.
                  YOYBUY Spreadsheet позволяет быстро оценить разницу в цене, качестве и условиях доставки.
                </p>
              </div>
              <div className="p-5 bg-secondary-50 rounded-2xl mb-5">
                <h4 className="text-base font-semibold text-foreground-800 mb-2">
                  Совет №2: Проверяйте дату обновления
                </h4>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Обращайте внимание на дату последнего обновления в таблице. Хотя данные обновляются ежедневно,
                  всегда лучше убедиться, что информация актуальна на момент заказа.
                </p>
              </div>
              <div className="p-5 bg-secondary-50 rounded-2xl">
                <h4 className="text-base font-semibold text-foreground-800 mb-2">
                  Совет №3: Используйте все категории
                </h4>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Не ограничивайтесь одной категорией. YOYBUY Spreadsheet охватывает 14 категорий — объединяйте заказы
                  из разных категорий для экономии на доставке.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                Часто задаваемые вопросы
              </h2>

              <div className="space-y-4">
                <div className="p-5 bg-background-100 rounded-2xl">
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">
                    Нужно ли регистрироваться на YOYBUY.PRO?
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Нет, регистрация на YOYBUY.PRO не требуется. Сайт является информационным хабом, который
                    перенаправляет вас напрямую к таблицам на Kaspreadsheet. Для оформления заказа может потребоваться
                    регистрация на платформе Kaspreadsheet.
                  </p>
                </div>
                <div className="p-5 bg-background-100 rounded-2xl">
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">
                    Как часто обновляются цены в таблицах?
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Данные в YOYBUY Spreadsheet обновляются ежедневно. Вы всегда получаете актуальную информацию
                    о ценах и наличии товаров.
                  </p>
                </div>
                <div className="p-5 bg-background-100 rounded-2xl">
                  <h4 className="text-base font-semibold text-foreground-800 mb-2">
                    Какие способы доставки доступны?
                  </h4>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Доступные способы доставки зависят от конкретного товара и поставщика. Подробная информация
                    указывается в таблице на Kaspreadsheet для каждой позиции.
                  </p>
                </div>
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                Готовы начать?
              </h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Переходите на Kaspreadsheet и получите доступ к полной системе таблиц YOYBUY Spreadsheet
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
                >
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link
                  to="/"
                  className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
                >
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors"
              >
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>

          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">
            YOYBUY<span className="text-accent-500">.PRO</span>
          </Link>
          <p className="mt-3 text-xs text-background-50/30">
            © 2026 YOYBUY.PRO. Все права защищены.
          </p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "YOYBUY Spreadsheet: Полное руководство по покупкам из Китая через систему таблиц",
          "description": "Узнайте, как использовать YOYBUY Spreadsheet для выгодных покупок из Китая. Пошаговое руководство по системе таблиц, сравнению цен и оптимизации заказов.",
          "datePublished": "2026-07-05",
          "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/yoybuy-spreadsheet-guide`}
        })}
      </script>
    </main>
  );
}